/**
 * @flow
 * @relayHash 5ff9a97712feac1879a054aa2ffe4236
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type EventPage_viewer$ref = any;
export type EventPageQueryRendererQueryVariables = {|
  eventId: string,
  language?: ?string,
  individualPart?: ?string,
|};
export type EventPageQueryRendererQueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: EventPage_viewer$ref
  |}
|};
export type EventPageQueryRendererQuery = {|
  variables: EventPageQueryRendererQueryVariables,
  response: EventPageQueryRendererQueryResponse,
|};
*/


/*
query EventPageQueryRendererQuery(
  $eventId: ID!
  $language: String
  $individualPart: String
) {
  viewer {
    ...EventPage_viewer
    id
  }
}

fragment EventAvailableSearchActions_info on Event {
  mainSearch
  sgId
  presaleMessage
  presale
  gps
  searchDual
  searchCollections
  participantUser
  secondFactorType {
    type
    id
  }
  ...PresaleEventInfo_eventPresaleInfo
  ...EventSearchOptions_eventSearchOptionsInfo
  ...InactiveEventInfo_eventInfo
}

fragment EventBar_event on Event {
  participantUser
  hostResultUrl
  beginsAt
  name
  sgId
  banner
  hostHomepageUrl
  hostHomepageName
  location
  voucherCampaigns {
    id
  }
  products {
    type
    id
  }
}

fragment EventCommonPart_event on Event {
  sgId
  ...EventBar_event
}

fragment EventInfoCard_eventInfo on Event {
  id
  sgId
  beginsAt
  banner
  hostHomepageName
  hostHomepageUrl
  location
  name
  predecessorEvent {
    name
    id
  }
}

fragment EventOnlineView_onlineEvent on Event {
  id
  sgId
  hostResultUrl
  name
  participantUser
  mainSearch
  dialogBeforeSearch
  dialogBeforeSecondFactor
  presale
  ...EventAvailableSearchActions_info
  ...EventInfoCard_eventInfo
  ...StartNumberSearch_info
}

fragment EventPage_viewer on Viewer {
  event(id: $eventId, language: $language) {
    id
    sgId
    beginsAt
    gps
    name
    legacy
    secondFactorType {
      type
      id
    }
    participantUser
    state
    searchDual
    searchCollections
    subEvents {
      id
    }
    successorEvent {
      ...PastEventInformation_successorEvent
      id
    }
    voucherCampaigns {
      id
    }
    products {
      type
      id
    }
    marathonFoto
    ...EventPendingView_pendingEvent
    ...EventOnlineView_onlineEvent
    ...Pricelist_offer
    ...EventBar_event
    ...EventCommonPart_event
  }
}

fragment EventPendingView_pendingEvent on Event {
  id
  sgId
  name
  ...EventInfoCard_eventInfo
}

fragment EventSearchOptions_eventSearchOptionsInfo on Event {
  id
  sgId
  mainSearch
  searchDual
  gps
  searchCollections
  ...ExtendedSearchCategorySearchTab_categories
  ...ExtendedSearchDualSearchTab_event
  ...StartNumberSearch_info
}

fragment ExtendedSearchCategorySearchTab_categories on Event {
  sgId
  mediaCollections {
    id
    name
  }
  searchAllPhotos
}

fragment ExtendedSearchDualSearchTab_event on Event {
  id
  sgId
  mainSearch
  ...StartNumberSearch_info
}

fragment InactiveEventInfo_eventInfo on Event {
  noMainSearchText
  participantUser
  secondFactorType {
    type
    id
  }
}

fragment PastEventInformation_successorEvent on Event {
  sgId
  beginsAt
}

fragment PresaleEventInfo_eventPresaleInfo on Event {
  presaleMessage
  presale
}

fragment Pricelist_offer on Event {
  products {
    id
    mediaCollection {
      name
      id
    }
    price
    type
    configuration {
      __typename
      ... on SingleVideoConfiguration {
        previewVideoUrl
      }
      ... on EventCertificateConfiguration {
        previewImageUrl
      }
    }
  }
  voucherCampaigns {
    id
    banner
    longText
    name
    shortText
    url
  }
  state
}

fragment StartNumberSearch_info on Event {
  id
  gps
  mainSearch
  searchDual
  secondFactorEventSalt(individualPart: $individualPart)
  secondFactorType {
    type
    id
  }
  sgId
  hostResultUrl
  faceWebcamOnly
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "eventId",
    "type": "ID!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "language",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "individualPart",
    "type": "String",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "sgId",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "beginsAt",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "type",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "banner",
  "args": null,
  "storageKey": null
},
v7 = [
  (v4/*: any*/),
  (v1/*: any*/)
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "EventPageQueryRendererQuery",
    "type": "RootQueryType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "EventPage_viewer",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "EventPageQueryRendererQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "event",
            "storageKey": null,
            "args": [
              {
                "kind": "Variable",
                "name": "id",
                "variableName": "eventId"
              },
              {
                "kind": "Variable",
                "name": "language",
                "variableName": "language"
              }
            ],
            "concreteType": "Event",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "gps",
                "args": null,
                "storageKey": null
              },
              (v4/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "legacy",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "secondFactorType",
                "storageKey": null,
                "args": null,
                "concreteType": "SecondFactorType",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v1/*: any*/)
                ]
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "participantUser",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "state",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "searchDual",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "searchCollections",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "subEvents",
                "storageKey": null,
                "args": null,
                "concreteType": "Event",
                "plural": true,
                "selections": [
                  (v1/*: any*/)
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "successorEvent",
                "storageKey": null,
                "args": null,
                "concreteType": "Event",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v1/*: any*/)
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "voucherCampaigns",
                "storageKey": null,
                "args": null,
                "concreteType": "VoucherCampaign",
                "plural": true,
                "selections": [
                  (v1/*: any*/),
                  (v6/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "longText",
                    "args": null,
                    "storageKey": null
                  },
                  (v4/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "shortText",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "url",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "products",
                "storageKey": null,
                "args": null,
                "concreteType": "Product",
                "plural": true,
                "selections": [
                  (v5/*: any*/),
                  (v1/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "mediaCollection",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "MediaCollection",
                    "plural": false,
                    "selections": (v7/*: any*/)
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "price",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "configuration",
                    "storageKey": null,
                    "args": null,
                    "concreteType": null,
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "__typename",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "type": "SingleVideoConfiguration",
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "previewVideoUrl",
                            "args": null,
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "kind": "InlineFragment",
                        "type": "EventCertificateConfiguration",
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "previewImageUrl",
                            "args": null,
                            "storageKey": null
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "marathonFoto",
                "args": null,
                "storageKey": null
              },
              (v6/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "hostHomepageName",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "hostHomepageUrl",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "location",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "predecessorEvent",
                "storageKey": null,
                "args": null,
                "concreteType": "Event",
                "plural": false,
                "selections": (v7/*: any*/)
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "hostResultUrl",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "mainSearch",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "dialogBeforeSearch",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "dialogBeforeSecondFactor",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "presale",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "presaleMessage",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "mediaCollections",
                "storageKey": null,
                "args": null,
                "concreteType": "MediaCollection",
                "plural": true,
                "selections": [
                  (v1/*: any*/),
                  (v4/*: any*/)
                ]
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "searchAllPhotos",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "secondFactorEventSalt",
                "args": [
                  {
                    "kind": "Variable",
                    "name": "individualPart",
                    "variableName": "individualPart"
                  }
                ],
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "faceWebcamOnly",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "noMainSearchText",
                "args": null,
                "storageKey": null
              }
            ]
          },
          (v1/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "EventPageQueryRendererQuery",
    "id": null,
    "text": "query EventPageQueryRendererQuery(\n  $eventId: ID!\n  $language: String\n  $individualPart: String\n) {\n  viewer {\n    ...EventPage_viewer\n    id\n  }\n}\n\nfragment EventAvailableSearchActions_info on Event {\n  mainSearch\n  sgId\n  presaleMessage\n  presale\n  gps\n  searchDual\n  searchCollections\n  participantUser\n  secondFactorType {\n    type\n    id\n  }\n  ...PresaleEventInfo_eventPresaleInfo\n  ...EventSearchOptions_eventSearchOptionsInfo\n  ...InactiveEventInfo_eventInfo\n}\n\nfragment EventBar_event on Event {\n  participantUser\n  hostResultUrl\n  beginsAt\n  name\n  sgId\n  banner\n  hostHomepageUrl\n  hostHomepageName\n  location\n  voucherCampaigns {\n    id\n  }\n  products {\n    type\n    id\n  }\n}\n\nfragment EventCommonPart_event on Event {\n  sgId\n  ...EventBar_event\n}\n\nfragment EventInfoCard_eventInfo on Event {\n  id\n  sgId\n  beginsAt\n  banner\n  hostHomepageName\n  hostHomepageUrl\n  location\n  name\n  predecessorEvent {\n    name\n    id\n  }\n}\n\nfragment EventOnlineView_onlineEvent on Event {\n  id\n  sgId\n  hostResultUrl\n  name\n  participantUser\n  mainSearch\n  dialogBeforeSearch\n  dialogBeforeSecondFactor\n  presale\n  ...EventAvailableSearchActions_info\n  ...EventInfoCard_eventInfo\n  ...StartNumberSearch_info\n}\n\nfragment EventPage_viewer on Viewer {\n  event(id: $eventId, language: $language) {\n    id\n    sgId\n    beginsAt\n    gps\n    name\n    legacy\n    secondFactorType {\n      type\n      id\n    }\n    participantUser\n    state\n    searchDual\n    searchCollections\n    subEvents {\n      id\n    }\n    successorEvent {\n      ...PastEventInformation_successorEvent\n      id\n    }\n    voucherCampaigns {\n      id\n    }\n    products {\n      type\n      id\n    }\n    marathonFoto\n    ...EventPendingView_pendingEvent\n    ...EventOnlineView_onlineEvent\n    ...Pricelist_offer\n    ...EventBar_event\n    ...EventCommonPart_event\n  }\n}\n\nfragment EventPendingView_pendingEvent on Event {\n  id\n  sgId\n  name\n  ...EventInfoCard_eventInfo\n}\n\nfragment EventSearchOptions_eventSearchOptionsInfo on Event {\n  id\n  sgId\n  mainSearch\n  searchDual\n  gps\n  searchCollections\n  ...ExtendedSearchCategorySearchTab_categories\n  ...ExtendedSearchDualSearchTab_event\n  ...StartNumberSearch_info\n}\n\nfragment ExtendedSearchCategorySearchTab_categories on Event {\n  sgId\n  mediaCollections {\n    id\n    name\n  }\n  searchAllPhotos\n}\n\nfragment ExtendedSearchDualSearchTab_event on Event {\n  id\n  sgId\n  mainSearch\n  ...StartNumberSearch_info\n}\n\nfragment InactiveEventInfo_eventInfo on Event {\n  noMainSearchText\n  participantUser\n  secondFactorType {\n    type\n    id\n  }\n}\n\nfragment PastEventInformation_successorEvent on Event {\n  sgId\n  beginsAt\n}\n\nfragment PresaleEventInfo_eventPresaleInfo on Event {\n  presaleMessage\n  presale\n}\n\nfragment Pricelist_offer on Event {\n  products {\n    id\n    mediaCollection {\n      name\n      id\n    }\n    price\n    type\n    configuration {\n      __typename\n      ... on SingleVideoConfiguration {\n        previewVideoUrl\n      }\n      ... on EventCertificateConfiguration {\n        previewImageUrl\n      }\n    }\n  }\n  voucherCampaigns {\n    id\n    banner\n    longText\n    name\n    shortText\n    url\n  }\n  state\n}\n\nfragment StartNumberSearch_info on Event {\n  id\n  gps\n  mainSearch\n  searchDual\n  secondFactorEventSalt(individualPart: $individualPart)\n  secondFactorType {\n    type\n    id\n  }\n  sgId\n  hostResultUrl\n  faceWebcamOnly\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'd456617f1b456508bd492ac52b789907';

module.exports = node;
